var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-snackbar',{attrs:{"md-position":"center","md-duration":Infinity,"md-active":_vm.toast.visible,"md-persistent":""}},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.toast.message)))])])}
var staticRenderFns = []

export { render, staticRenderFns }